import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from './layout.service';
import { helper } from '../../environments/helper';

@Injectable({
	providedIn: 'root',
})
export class DialogService {
	dialogRef!: MatDialogRef<any>;

	constructor(private layoutService: LayoutService) { }

	getDialogConfig(title: string =  helper.dialogConfig.headers.errorAtentie, 
					msg: string = helper.dialogConfig.generalMessages.error) {
		return {
			minWidth: !this.layoutService.isXS() ? 500 : 340,
			maxWidth: 600,
			maxHeight: '90vh',
			autoFocus: false,
			disableClose: true,
			data: {
				title,
				msg
			}
		};
	}

	closeDialog() {
		this.dialogRef?.close();
	}
}
